import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

//Services
import CorporateApi from "Services/CorporateGroup";

//DropZone
// import DropZone from "./DropZone";

//Data
import countryCodeData from "./data/countryCode/index.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PassengerUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  // Fetch Passenger Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    CorporateApi.getCorpGrpDetails(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdateCorporategrp = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

 const data = {
      corporateGroupName: formValues?.corporateGroupName,
      autopay:formValues?.autopay,
    };

    //console.log('data--->',data);

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Corporate Grp Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update Corporate grp",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      CorporateApi.updateCorporategrp(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue("corporateGroupName", details?.corporateGroupName);
      formik.setFieldValue("autopay", details?.autopay);
    }
  }
    updateFormValues();
  }, [details]);

  // Formik
 const formik = useFormik({
    initialValues: {
      corporateGroupName: "",
      autopay:true
    },
    validationSchema: yup.object({
      corporateGroupName: yup.string().required("Group Name is required").nullable()
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateCorporategrp,
  });

  const countryCodes = Object.keys(countryCodeData);

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Group
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>

          <Grid container>

          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="corporateGroupName"
                          label="Group Name"
                          value={formik?.values?.corporateGroupName}
                          defaultValue={formik?.values?.corporateGroupName}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.corporateGroupName &&
                            formik?.touched?.corporateGroupName
                          }
                          helperText={
                            formik?.errors?.corporateGroupName &&
                            formik?.touched?.corporateGroupName &&
                            formik?.errors?.corporateGroupName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
<FormControl component="fieldset" className={classes.textFieldWrapper}>
  <FormLabel component="legend">Payment Mode</FormLabel>
  <RadioGroup
    aria-label="paymentMode"
    name="autopay"
    value={formik.values.autopay ? "true" : "false"}
    onChange={formik.handleChange}
  >
    <FormControlLabel
      value="true"
      control={<Radio checked disabled />}
      label={
        <>
          <Typography variant="body2" style={{ fontWeight: "bold" }}>
            Auto-Paid By Company
          </Typography>
          <Typography variant="caption">
            Ride bills are automatically deducted from your corporate account
          </Typography>
        </>
      }
    />
  </RadioGroup>
</FormControl>                        
                      </Grid>

</Grid>
</Grid>
</Grid>
</Grid>

       </section>
                </Grid>

                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Update Group
                    </Button>
                  </Grid>
                </Grid>

              </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PassengerUpdate;
